module.exports = __webpack_public_path__ + "img/under-construction.d25ff0d0.svg";